module.exports = __webpack_public_path__ + "static/media/welcome.3c940ad1.svg";